<template>
  <div v-if="mng" id="Order">
     <!-- Catalog -->
      <div v-if="acti===9" class="input-group md-form form-sm form-2 pl-0 mb-3">
        <template v-if="goods.length > 0">
         <div class="input-group-prepend" v-scroll-to="{el:'#' + lastedited,offset: -70}">
             <span class="input-group-text text-white blue" title=""><i class="fa fa-search text-grey" aria-hidden="true" ></i></span>
        </div>
        <input ref="inp" class="form-control" v-bind:class="{'red-text':filteredList.length === 0 && goods.length > 0, 'text-primary':filteredList.length > 100 &&  filteredList.length < goods.length}" v-model.trim="search" type="text" placeholder="Поиск" aria-label="Search" title="Введи ключевые слова в поле поиска">
        <span class="input-group-text text-white red hoverable" title="Очистить поле ввода" @click="search=''" id="basic-text1"><i class="fa fa-times text-grey" aria-hidden="true"></i></span>
      </template>
      </div>
       <badge color="warning-color" v-if="loading">ЖДИТЕ!!! Выполняется расчет на вашем компьютере. В зависимости от быстродействия - 1 - 5 мин.</badge>
       <template v-if="search.length === 0 && goods.length > 0">
       <div v-if="folder1 === '00000000-0000-0000-0000-000000000000' && folder2 === '00000000-0000-0000-0000-000000000000'" class="card-deck">
       </div>
       </template>
        <template v-if="filteredList.length === 0 && goods.length > 0 && search!=''">
       <div class="card col">
        <div class="card-body">
         <blockquote class="blockquote bq-danger">
           <p class="bq-title text-center">Ничего не найдено - папка не содержит товаров или неверный запрос</p>
          </blockquote>
        </div>
      </div>
       </template>
       <div v-if="(filteredList.length < 300 || orderedOnly) && !loading">
        <div v-for="(good, index) in filteredList" :key="index" class="card md-1 mt-1" :id=calculateid(good.Ref_Key) v-bind:class="{'blue lighten-5' : good.changed === true }">
        <div @click.passive="good.ShowPicture = !good.ShowPicture" v-if="good.ShowPicture" class="view zoom view-cascade view overlay justify-content-md-center">
            <img class="card-img-top img-fluid z-depth-1" :src='good.ФайлКартинки' alt="Фото">
          </div>
        <!-- Card content -->
          <div class="card-body mt-0 md-0">
              <!-- Text -->
                <div class="card-text" v-bind:class="{'black-text' : good.toOrder>0 }">
                <b>   {{good.Артикул}} </b> {{good.НаименованиеПолное}}
              </div>
            </div>
             <div class="card-footer d-flex flex-wrap justify-content-end">
                 <div v-if="mng" class="input-group-prepend col" style="cursor: pointer;">
                    <span class="input-group-text success-color-dark text-white" title='На складе в Минске'>{{good.Stock}}</span>
                    <span v-if="good.ВРезерве > 0 " class="input-group-text warning-color-dark text-white" title='В резерве'>{{good.ВРезерве}}</span>
                    <span class="input-group-text default-color text-white"  v-bind:title="transit(good)">{{good.DeliveryQty}}</span>
                    <span class="input-group-text secondary-color-dark text-white" title='На складе в Литве'>{{good.StockS}}</span>
                  </div>
                  <span  style="cursor: pointer;" class="input-group-text unique-color-dark text-white" title='Класс'>{{good.classABCXYZ}}</span>
                  <button style="cursor: pointer;" @click.prevent="getGoodSales(good.Ref_Key)" class="hoverable input-group-text unique-color-dark text-white" title='Продано за полгода'>{{good.ABCЗначениеПараметраКлассификации}}</button>
                 <input class="form-control col-3 animated fadeIn" v-bind:class=" {'stock': good.StockS, 'miss': ((good.StockS===0) && (good.DeliveryQty===0)), 'transit':((good.Stock===0) && (good.DeliveryQty>0)), 'skorpiono' : good.StockS===0 && good.DeliveryQty===0 && good.StockS > 0} " type="number" v-bind:value="good.toOrder" @input="good.toOrder=calculateInput(good,$event)" @keyup="good.toOrder=calculateInput(good,$event)" @mousevent="good.toOrder=calculateInput(good,$event)" aria-label="Количество для заказа, используйте стрелки вверх-вниз для изменения" title="Количество для заказа, используйте стрелки вверх-вниз для изменения">
              </div>
           </div>
          </div>
         <modal size="lg" v-if="showModal" @close="showModal = false">
          <modal-header>
            <modal-title>Движения товара за последние 2 месяца по неделям</modal-title>
          </modal-header>
          <modal-body>
            <mdb-container>
              <mdb-line-chart :data="lineChartData" :options="lineChartOptions" :width="600" :height="300"></mdb-line-chart>
              </mdb-container></modal-body>
          </modal>
         <back-to-top bottom="30px" right="30px">
          <button @click="$refs.inp.focus()" type="button" class="btn  red darken-3 hoverable btn-to-top d-none d-lg-block"><i class="fa fa-chevron-up"></i></button>
        </back-to-top>
    </div>
</template>

<script>
import {Row, Column, Btn, Card, CardBody, CardHeader, CardText, Fa, BarChart, PieChart, LineChart, RadarChart, DoughnutChart, ListGroup, ListGroupItem, Badge, Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Carousel, CarouselItem, CarouselCaption, mdbLineChart, mdbContainer} from 'mdbvue'
import ApiService from '@/services/ApiService'
import format from 'date-fns/format'
import subDays from 'date-fns/sub_days'
export default {
  name: 'order',
  components: {
    Row,
    Column,
    Btn,
    Card,
    CardBody,
    CardHeader,
    CardText,
    Fa,
    BarChart,
    PieChart,
    LineChart,
    RadarChart,
    DoughnutChart,
    ListGroup,
    ListGroupItem,
    Badge,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Carousel,
    CarouselItem,
    CarouselCaption,
    mdbLineChart,
    mdbContainer
  },
  props: ['authorized', 'acti', 'goods', 'orders', 'mng', 'folder1', 'folder2', 'orderedOnly', 'selectedSchema', 'supplierOrder'],
  data () {
    return {
      lastedited: '',
      loading: false,
      showModal: false,
      results: [],
      goodsabc: [],
      reserves: [],
      goodsSales: [],
      goodSales: [],
      goodBuy: [],
      goodStock: [],
      search: '',
      itemsSelected: 0,
      keys: ['Артикул', 'НаименованиеПолное'],
      hideSearchTip: false,
      closetags: false,
      inlist: false,
      lineChartData: {
        labels: ['8', '7', '6', '5', '4', '3', '2', '1', '0', 'Прогноз'],
        datasets: [
          {
            label: 'Проджи',
            backgroundColor: 'rgba(245, 74, 85, 0.5)',
            data: this.goodSales
          },
          {
            label: 'Остатки',
            backgroundColor: 'rgba(245, 192, 50, 0.5)',
            data: this.goodStock
          },
          {
            label: 'Покупки',
            backgroundColor: 'rgba(90, 173, 246, 0.5)',
            data: this.goodBuy
          }
        ]
      },
      lineChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            }
          }]
        }
      }
    }
  },
  mounted () {
    this.loading = true
    this.getGoodsABCXYZ()
    this.getGoodsReserves()
    this.getGoodsSalesByPeriod()
    this.$bus.$on('CreateSupplierOrder', ($event) => {
      console.log('My event has been triggered')
      this.CreateSupplierOrder()
    })
  },
  updated () {
    console.log('updated')
  },
  created () {
  },
  computed: {
    filteredList () {
      return this.goods.filter(good => {
        // console.log(this.orderedOnly + ' ' + good.toOrder)
        // if (this.orderedOnly && good.toOrder) return true
        if ((good.Parent_Key !== this.folder1 && good.Parent_Key !== this.folder2) && (this.folder1 !== '00000000-0000-0000-0000-000000000000' && this.folder2 !== '00000000-0000-0000-0000-000000000000')) return false
        if (this.folder1 === '00000000-0000-0000-0000-000000000000' && this.folder2 !== '00000000-0000-0000-0000-000000000000') return false
        var keywords = this.search.split(' ')
        var res = true
        keywords.forEach((element, index) => {
          // console.log(good.НаименованиеПолное)
          var str = good.Артикул + ' ' + good.НаименованиеПолное
          var res1 = str.toString().toLowerCase().includes(element.toString().toLowerCase())
          if (this.orderedOnly) {
            if (res === true && res1 === true && (this.selectedSchema === good.СхемаОбеспечения_Key || this.selectedSchema === '00000000-0000-0000-0000-000000000000') && good.toOrder > 0) res = true
            if (res === false || res1 === false || good.toOrder === '') res = false
          } else {
            if (res === true && res1 === true && (this.selectedSchema === good.СхемаОбеспечения_Key || this.selectedSchema === '00000000-0000-0000-0000-000000000000')) res = true
            if (res === false || res1 === false || good.toOrder !== '') res = false
          }
        })
        return res
      })
    },
    element (good) {
      return good.Ref_Key
    },
    showpicture () {
      // console.log(this)
      return true
    }
  },
  watch: {
    selectedSchema () {
      this.calculateOrder()
    }
  },
  methods:
    {
      async getGoodSales (uid) {
        console.log('getGoodSales ' + uid)
        for (var i = 0; i <= 8; i++) {
          var startDate = format(subDays(Date(), i * 7 + 7), 'YYYY-MM-DD')
          var endDate = format(subDays(Date(), i * 7 - 1), 'YYYY-MM-DD')
          const response = await ApiService.goodSalesByPeriod(uid, startDate, endDate)
          let data = response.data.value
          if (data.length > 0) {
            this.goodSales[8 - i] = data[0].ВНаличииExpense
            this.goodBuy[8 - i] = data[0].ВНаличииReceipt
            this.goodStock[8 - i] = data[0].ВНаличииClosingBalance
          } else {
            this.goodSales[8 - i] = 0
            this.goodBuy[8 - i] = 0
            this.goodStock[8 - i] = 0
          }
        }
        this.lineChartData = {
          labels: ['8', '7', '6', '5', '4', '3', '2', '1', '0', 'Прогноз'],
          datasets: [
            {
              label: 'Проджи',
              backgroundColor: 'rgba(245, 74, 85, 0.5)',
              data: this.goodSales
            },
            {
              label: 'Остатки',
              backgroundColor: 'rgba(245, 192, 50, 0.5)',
              data: this.goodStock
            },
            {
              label: 'Покупки',
              backgroundColor: 'rgba(90, 173, 246, 0.5)',
              data: this.goodBuy
            }
          ]
        }
        this.showModal = true
      },
      async CreateSupplierOrder () {
        console.log('CreateSupplierOrder - ORDER')
        await ApiService.createSupplierOrder()
        const response = await ApiService.getSupplierOrders()
        let data = response.data.value
        console.log(data)
        var goodsToOtder = this.filteredList
        // console.log(goodsToOtder)
        var uid = data[0].Ref_Key
        var orderGoods = []
        goodsToOtder.forEach((good, index) => {
          orderGoods[index] = {}
          orderGoods[index].LineNumber = index + 1
          orderGoods[index].КодСтроки = index + 1
          orderGoods[index].Ref_Key = uid
          orderGoods[index].Количество = good.toOrder
          orderGoods[index].КоличествоУпаковок = good.toOrder
          orderGoods[index].Номенклатура_Key = good.Ref_Key
          orderGoods[index].Сумма = good.toOrder * 1
          orderGoods[index].СуммаСНДС = good.toOrder * 1
          orderGoods[index].Цена = 1
          orderGoods[index].СтавкаНДС = 'БезНДС'
          orderGoods[index].Склад_Key = '17631cba-e764-11e5-a13e-00e04d95380f'
        })
        var dataVersion = data[0].DataVersion
        var jsonString = JSON.stringify(orderGoods)
        console.log(jsonString)
        const response1 = await ApiService.patchSupplierOrder(uid, jsonString, dataVersion)
        console.log(response1)
        this.$dialog.alert('Заказ сохранен в базе!').then(function (dialog) {
          // console.log('Sent')
        })
      },
      calculateInput (good, event) {
        good.changed = true
        this.lastedited = this.calculateid(good.Ref_Key)
        console.log('good.changed ' + good.changed)
        if (event.target.value < 1) {
          event.target.value = ''
          return ''
        } else {
          return event.target.value
        }
      },
      ChangeItem (good) {
        this.$emit('orderedItems')
      },
      calculateid (refkey) {
        return 'card-' + refkey
      },
      transit (good) {
        return 'Транзит к ' + this.$moment(good.DeliveryDate).format('DD-MM-YYYY')
      },
      async calculateOrder () {
        this.loading = true
        console.log('calculateOrder')
        this.goods.forEach((good) => {
          var res = this.reserves.filter(reserv => good.Ref_Key === reserv.Номенклатура_Key)
          // console.log(res)
          if (res.length > 0) good.ВРезерве = res[0].ЗаказаноBalance
          else good.ВРезерве = 0
        })
        this.goods.forEach((good) => {
          var OrderedQty = 0
          var sales = 0
          good.ABCЗначениеПараметраКлассификации = 0
          const result = this.goodsSales.filter(sales => sales.Номенклатура_Key === good.Ref_Key)
          if (result.length > 0) {
            // console.log(good.Ref_Key + ' ' + result[0].ВНаличииExpense)
            good.ABCЗначениеПараметраКлассификации = result[0].ВНаличииExpense
            sales = result[0].ВНаличииExpense
          } else good.ABCЗначениеПараметраКлассификации = 0
          if (this.selectedSchema === good.СхемаОбеспечения_Key && this.selectedSchema !== '00000000-0000-0000-0000-000000000000') {
            if (this.selectedSchema === 'f0171508-6138-11e7-ac65-001dd8b723ef') {
              OrderedQty = Math.round(sales / 24 - good.Stock - good.DeliveryQty + good.ВРезерве)
            } else {
              OrderedQty = Math.round(sales / 6 - good.Stock - good.DeliveryQty + good.ВРезерве)
            }
            if (OrderedQty > 0) good.toOrder = OrderedQty
            else good.toOrder = ''
          }
          if (this.selectedSchema === '00000000-0000-0000-0000-000000000000') {
            if (good.СхемаОбеспечения_Key === 'f0171508-6138-11e7-ac65-001dd8b723ef') {
              OrderedQty = 0
            } else if (good.StockS < good.ABCЗначениеПараметраКлассификации) {
              OrderedQty = Math.round(good.ABCЗначениеПараметраКлассификации - good.StockS)
            }
            if (OrderedQty > 6) good.toOrder = OrderedQty
            else good.toOrder = ''
          }
        })
        console.log('Calculation finished')
        this.loading = false
      },
      async getGoodsABCXYZ () {
        console.log('getGoodsABCXYZ')
        let answer = await ApiService.getGoodsABCXYZ()
        this.goodsabc = answer.data.value
        this.goods.forEach((good) => {
          good.classABCXYZ = 'UU'
          var cl = this.goodsabc.filter(abc => abc.Номенклатура_Key === good.Ref_Key)
          var abc = ''
          var xyz = ''
          if (cl.length > 0) {
            cl.forEach((el) => {
              if (el.ТипКлассификации === 'ABC') abc = el.Класс
              if (el.ТипКлассификации === 'XYZ') xyz = el.Класс
            })
            if (abc === 'AКласс') good.classABCXYZ = 'A'
            if (abc === 'BКласс') good.classABCXYZ = 'B'
            if (abc === 'CКласс') good.classABCXYZ = 'C'
            if (abc === 'НеКлассифицирован') good.classABCXYZ = 'U'
            if (xyz === 'XКласс') good.classABCXYZ += 'X'
            if (xyz === 'YКласс') good.classABCXYZ += 'Y'
            if (xyz === 'ZКласс') good.classABCXYZ += 'Z'
            if (xyz === 'НеКлассифицирован') good.classABCXYZ += 'U'
            // console.log(good.classABCXYZ)
          }
        })
        this.calculateOrder()
      },
      async getGoodsSalesByPeriod () {
        console.log('goodsSalesByPeriod')
        var startDate = format(subDays(Date(), 180), 'YYYY-MM-DD')
        var endDate = format(subDays(Date(), 0), 'YYYY-MM-DD')
        let answer = await ApiService.goodsSalesByPeriod(startDate, endDate)
        this.goodsSales = answer.data.value
        // console.log(answer.data.value)
      },
      async getGoodsReserves () {
        console.log('getGoodsReserves')
        let answer = await ApiService.getGoodsReserves()
        this.reserves = answer.data.value
        // console.log(answer.data.value)
      },
      searchFocus (str) {
        this.showOnce = false
        this.$refs.inp.focus()
        // console.log(str)
        this.search += str
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .btn-to-top {
    border-radius: 50%;
    padding: 1rem;
    padding-top: 0.9rem;
    padding-right: 1.1rem;
    padding-bottom: 0.9rem;
    padding-left: 1.1rem;
  }
.btn.btn-nav {
    padding: 0.1rem 1.0rem;
    font-size: 0.64rem;
  }
.badge-pill {
    border-radius: 10rem;
    padding-right: 0.6em;
    margin-top: 0.6em;
  }
.form-control:focus {
    border:0px
    }
.form-control {
    height:auto
    }
.order-btn {
    margin-top: 0.375rem;
    margin-left: 0rem;
    }
.search {
    border: 1px solid #1e282d;
    }
.stock {
    border: 1px solid #007e33;
    }
.miss {
    border: 1px solid #d50000;
    }
 .skorpiono {
    border: 1px solid #9933cc;
    }
.transit {
    border: 1px solid #ff8800;
    }
.w-120 {
    width: 120px!important;
}
.w-50 {
    width: 60px!important;
}
.inp {
    font-size: 1.5rem;
}
.md-form {
    position: relative;
    margin-top: 0rem;
    margin-bottom: 0rem;
}
.cascading-admin-card {
  padding-left: 5px;
  padding-right: 5px;
}
.m-0 {
    margin: 0.4rem!important;
}
.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
}
.cascading-admin-card .admin-up .fa {
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2), 0 2px 20px 0 rgba(0, 0, 0, 0.19);
}
.cascading-admin-card .admin-up .fa {
  padding: 1.7rem;
  font-size: 2rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  border-radius: 3px;
}
.cascading-admin-card .admin-up .data {
  float: right;
  margin-top: 2rem;
  text-align: right;
}
.admin-up .data p {
  color: #999999;
  font-size: 12px;
}
.classic-admin-card .card-body {
  color: #fff;
  margin-bottom: 0;
  padding: 0.9rem;
}
  .card-text {
  font-size: 16px;
  opacity: 1.0;
  margin-bottom: 0;
  margin-left: 1rem;
  font-weight: 300;
}
.classic-admin-card .card-body h4 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Order.vue